export const MOBILE_VIEW = 480;
export const TABLET_VIEW = 768;
